<template>
  <form @submit.prevent="validateForm" class="suspend-user ine-form__form">
    <div class="suspend-user__toggle-suspension-wrapper">
      <div
        class="suspend-user__toggle-suspension-btn"
        :class="suspend ? 'suspend-user__chosen' : ''"
        @click="suspend = true"
      >
        Suspend a User
      </div>
      <div
        class="suspend-user__toggle-suspension-btn"
        :class="!suspend ? 'suspend-user__chosen' : ''"
        @click="suspend = false"
      >
        Lift User Suspension
      </div>
    </div>
    <div class="ine-form__title-wrapper">
      <h4 class="ine-form__welcome">
        <span v-if="suspend">Suspend User</span>
        <span v-else>Lift a Suspension</span>
      </h4>
      <p class="ine-form__lead-in">
        Please enter the users email address
      </p>
    </div>
    <div class="ine-form__form-group">
      <input
        @keyup="validateEmail()"
        type="email"
        class="ine-form__form-control"
        placeholder="email"
        v-model="email"
      />
    </div>
    <div class="ine-form__submit-btn-wrapper">
      <button
        v-show="!loading"
        class="btn__auth ine-form__submit-btn"
        type="submit"
      >
        <span v-if="suspend">Suspend User</span>
        <span v-else>Lift Suspension</span>
        <span class="material-icons btn__auth--icon">person</span>
      </button>
      <ClipLoader
        v-show="loading"
        :size="1.5"
        sizeUnit="rem"
        class="ine-form__loading-spinner"
      ></ClipLoader>
    </div>
    <div v-show="!loading" class="ine-form__additional-links-wrapper">
      <router-link class="ine-form__additional-link" :to="{ name: 'home' }"
        >Back to Homepage</router-link
      >
    </div>
  </form>
</template>

<script>
import { ClipLoader } from '@saeris/vue-spinners'

export default {
  name: 'SuspendUser',
  components: {
    ClipLoader,
  },
  data() {
    return {
      email: '',
      suspend: true,
      loading: false,
    }
  },
  props: {
    emailValid: {
      type: Boolean,
      required: true,
    },
  },
  computed: {
    entriesValid() {
      return this.emailValid && this.email !== ''
    },
  },
  methods: {
    validateEmail() {
      this.$emit('emailTest', this.email)
    },
    async validateForm() {
      this.loading = true
      if (!this.emailValid || this.email === '') {
        this.$store.dispatch('app/setError', 'Please enter a valid email.')
      } else {
        const preparedEmail = this.email.toLowerCase().trim()
        if (this.suspend) {
          await this.suspendUser(preparedEmail)
        } else {
          await this.liftSuspension(preparedEmail)
        }
      }
      this.loading = false
    },
    async suspendUser(preparedEmail) {
      await this.$store.dispatch('admin/adminSuspendUser', preparedEmail)
    },
    async liftSuspension(preparedEmail) {
      await this.$store.dispatch('admin/adminLiftSuspension', preparedEmail)
    },
  },
}
</script>

<style lang="scss" scoped>
.suspend-user {
  &__toggle-suspension-wrapper {
    display: flex;
    justify-content: center;
    align-items: center;
    margin: 0 0 20px 0;
  }
  &__toggle-suspension-btn {
    border: 1px solid var(--black);
    background-color: var(--white);
    color: var(--black);
    padding: 5px 25px;
    cursor: pointer;
  }
  &__chosen {
    background-color: #ef7d21;
    color: #fff;
  }
}
</style>
